var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<web-component> <div class=\"web-component-bg\" ng-show=\"$ctrl.valid==true || ($ctrl.hotelLocation && $ctrl.hotelValid==true)\">  <div class=\"web-component-center\"> <h4 ng-if=\"$ctrl.Destination && $ctrl.showTitle != 'false'\" ng-click=\"$ctrl.consolelog()\"> {{ $ctrl.Destination.DestinationName }} </h4> <p ng-if=\"$ctrl.Destination.StreetAddress && $ctrl.Destination.PostAddress\"> {{ $ctrl.Destination.StreetAddress }}, {{ $ctrl.Destination.PostAddress }} </p> <div ng-show=\"$ctrl.hasGoogle\" id=\"reservation-map\"></div> <a target=\"_blank\" ng-if=\"$ctrl.lat != 0 && $ctrl.lng != 0\" href=\"https://www.google.fi/maps/place/{{ $ctrl.lat }}+{{ $ctrl.lng }}\" ng-i18next>common.open_bigger_map</a> </div> </div> </web-component>";
var id1="winresReservationMap.html";
ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresReservationMap/winresReservationMap.html
// module id = 416
// module chunks = 2